import React, { memo } from "react";
import { MdSearch } from "react-icons/md";

const SearchBar = ({ searchTerm, onSearchChange }) => {
  return (
    <div className="relative max-w-md flex-1">
      <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-xl text-gray-400" />
      <input
        type="text"
        placeholder="Rechercher un auteur..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="focus:border-transparent w-full rounded-lg border border-gray-300 py-2.5 pl-10 pr-4 transition-all focus:ring-2 focus:ring-[#57A863]"
      />
    </div>
  );
};

export default memo(SearchBar);
